<template>
  <modal :open="internalOpen" no-padding>
    <template #header>
      <modal-header variant="cross" @cancel="cancel">
        <h1>{{ $t('pages.notificationList.modal.confirm.title') }}</h1>
      </modal-header>
    </template>
    <div class="m-8">
      <div class="flex flex-col w-full">
        {{ showTriggeredWarning ? $t('pages.notificationList.modal.dateTriggered.warningMessage') : $t('pages.notificationList.modal.confirm.text', [ total ]) }}
        <div class="flex justify-end gap-4 mt-8">
          <custom-button variant="outlined" @click="cancel">
            {{ $t('pages.notificationList.modal.confirm.cancelText') }}
          </custom-button>
          <custom-button variant="primary" @click="confirm">
            {{ $t('pages.notificationList.modal.confirm.confirmText') }}
          </custom-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script setup lang="ts">
import Modal from '@utils/Modal/Modal.vue';
import { useVModel } from '@vueuse/core';
import ModalHeader from "@utils/Modal/ModalHeader.vue";
import { computed } from 'vue';

interface Props {
  open: boolean;
  number?: number|undefined;
  numberArray?: { number: number }[]|undefined;
  showTriggeredWarning?: boolean;
}

const emit = defineEmits(['update:open', 'confirm']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

const total = computed(() => {
  if (props.numberArray) {
    return props.numberArray.reduce((sum, item) => sum + item.number, 0);
  }
  return props.number;
});

const cancel = () => {
  emit('update:open', false);
};

const confirm = () => {
  emit('update:open', false);
  emit('confirm');
};

</script>
